export default "__VITE_ASSET__e716d409__"